import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AccountService } from '../account/account.service';

@Injectable({
   providedIn: 'root'
})
export class AccountGuard implements CanActivate {
   constructor(
      private router: Router,
      private account: AccountService,
   ) { }

   canActivate(
      _route: ActivatedRouteSnapshot,
      _state: RouterStateSnapshot
   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if ( !this.check() ) { return this.router.parseUrl( '/' ); }

      return true;
   }

   check() {
      return !!this.account.account && !this.account.error;
   }
}
